import type { DatiSensoreDinamicoDTO } from '../../dto/plc/dati-sensore-dinamico-dto'
import type { DynamicSensorReadings } from '../../types/plc/dynamic-sensor-readings'
import { mapToAccMeasureDTO, mapToDynamicSensoreReading } from './dynamic-sensor-reading-mapper'

const mapToDynamicSensorReadings = (dto: DatiSensoreDinamicoDTO): DynamicSensorReadings => {
    return {
        isAggregated: dto.isAggregated,
        readings: dto.datas?.map((reading) => mapToDynamicSensoreReading(reading)) ?? [],
    }
}

const mapToDatiSensoreDynamicDTO = (sensor: DynamicSensorReadings): DatiSensoreDinamicoDTO => {
    return {
        isAggregated: sensor.isAggregated,
        datas: sensor.readings.map((reading) => mapToAccMeasureDTO(reading)),
    }
}

export { mapToDatiSensoreDynamicDTO, mapToDynamicSensorReadings }
